export default {
  CLEARREDISCACHE: "/generic/redis/clear",
  FETCH: "/generic", // generic list
  DELETE: "/generic/deletion/header", // 删除generic
  GETMODULES: "/generic/modules", // 获取模块
  SAVE: "/generic", // 提交generic header config
  GETFUNCTION: "/generic/getFunction", // 获取功能
  GETBEGAVIORDETAIL: "/generic/behavior", // 获取behavior 列表
  GETSCHEMADETAIL: "/generic/schemas", // 获取DB Schema 列表
  GETPROPERTYDETAIL: "/generic/getPropertyDetail", // 获取Property列表
  DELETEPROPERTYDETAIL: "/generic/deletion/pageProperty", // 删除Property列表 接口有问题
  SORTPROPRTTYDETAIL: "/generic/pageProperty/sorting", // page pro 排序修接口POST
  SAVEPROPERTYDETAIL: "/generic/pageProperty", // 编辑保存page pro..
  GETSQLDETAIL: "/generic/sql", // 获取sql详情
  SAVEBEHAVIOR: "/generic/behavior", // 保存behavior
  GETSUBPAGE: "/generic/subPage", // h获取subage Detail
  GETBEHRDROPDATA: "/generic/dropdown/behavior", // 获取Behavior下拉框数据
  DELETEBEHAVIOR: "/generic/deletion/behavior", // 删除Behavior
  GETSUBPAGEDROPDATA: "/generic/getSubPageDropData", //  获取sub page下拉框数据
  GETMODULEDROPDATA: "/generic/dropdown/module", //  获取Behavior Generic Name module下拉框数据
  GETGENERICDROPDATA: "/generic/getGenericDropdata", //  配置gmc-uid 中的获取GERICNAME下拉框数据
  GETFUNCTIONDROPDATA: "/generic/dropdown/function", // 配置gmc-uid 中的获取function下拉框数据
  GETLOGINACCOUNTDATA: "/user/getLoginAccountList",  // 配置gmc-uid 中获取的user下拉框数据
  POSTFETCH: "/generic/dropdown/generic", // 获取generic 配置 提交获取gmc-uid
  SAVESUBPAGE: "/generic/subPage", // 保存save SUbpage
  DELETESUBPAGE: "/generic/deletion/subPage", // 删除subPage
  SAVESQLDETAIL: "/generic/sql", // 编辑sql
  GETSQLDROPDATA: "/generic/dropdown/sql", // 获取 sql 下拉框数据
  REFRESHPROPERTYDETAIL: "/generic/schema2PageProperty", // 获取PRO详情
  GENERICQUERYCONDITION:"/generic/query/condition",
  GETPROJECTCODEANDPROJECTLIST: "/generic/getProjectCodeAndProjectList",
  COPYTOPROJECTLIST: "/generic/copyToProjectList",
  COPYTONEWPROJECT: "/generic/copyToNewProject",
  QUERYMODULE: "/generic/query/module",
  GETINTERNATIONALLANGUAGE: "/generic/getInternationalLanguage",
  QUERYCONDITIONLIST: "/generic/queryConditionList",
  SAVEQUERYCONDITION: "/generic/saveQueryCondition",
  SAVEQUERYCONDITIONSORT:"/generic/query/saveQueryConditionSort",
  DELETEQUERYCONDITION: "/generic/deleteQueryCondition",
  GENERICMASTERCONFIGSQL: "/generic/master/config/sql",
  GENERICMASTERCONFIGSQLSAVE: "/generic/master/config/sql/save",
  GENERICMASTERCONFIGSQLGENERATE: "/generic/master/config/sql/generate",
  GETFIELDNAMEBYSCHEMA: "/generic/dropdown/getFieldNameBySchema",
  GETDATABYCODEMASTERGROUP: "/generic/dropdown/getDataByCodeMasterGroup",
  GETCODEMASTERGROUP: "/generic/dropdown/getCodeMasterGroup",
  GETFIELDNAMEDROPDATA: "/generic/dropdown/fieldName", // 获取Field Name下拉框数据
  DELETESQLPARAMETERS: "/generic/deletion/sql", // 删除SqlParameters
  ISSUE: "/generic/publish", // 发布
  COPY: "/generic/copy", // 复制
  GETGMCMENU: "/generic/gmcMemu", // 获取Generic Menu
  GETUSERMENU: "/user/menu", // 获取user Menu
  EXTENTIONVALUETYPE: "/generic/extentionValueType",
  FIELMAP: "/generic/fieldMap", // 获取 fieldMap
  FIELMAPDETAIL: "/generic/fieldMapDetail", // 获取某一条fieldMap配置的详细信息
  DELETIONFIELMAP: "/generic/deletion/FieldMap", // 删除fieldMap配置
  DROPFIELMAP: "/generic/dropdown/fieldMap", // 获取 fieldMap 下拉数据
  SUBFIELMAP: "/generic/subFieldMap", // 添加 sub fieldMap配置
  DELETESUBFIELMAP: "/generic/deletion/SubFieldMap", // 删除 sub fieldMap配置
  MAPPROJECT: "/generic/dropdown/project", // 获取map to project 下拉data
  BUTGROUP: "/generic/behr/group", // 给按钮分组
  ADVANCETEMPLATE: "/generic/module/dropdown/template", // 获取advance search template下拉数据
  VALIDSQL: "/generic/validSql",
  DELETEVALISQL: "/generic/deletion/validSql",
  SECTIONNAME: "/generic/sectionName", // page groupname
  GETPRINTPRICETAGTABS: "/generic/printPriceTag/tabs",
  GENERICMON: "/generic/mon",
// buttonconfig
    GENERICPROJECTLIST:"/generic/project/list",
    GENERICPRINTNODEFUNCTION:"/generic/printNode/function",
    GERNERICPRINTNODEACTION:"/generic/printNode/action",

    GENERICPRINTNODEBTNCONFIG:"/generic/printNode/btn/config",
    GENERICPRINTNODEALLBTNCONFIG: "/generic/printNode/allBtn/config",
    GENERICLASTLPN: "/generic/LastLPN",
    GETLASTLPNBYCODEMAST: "/generic/getLastLPNByCodeMast",
    GENERICLASTLPNBYTYPE: "/generic/getLastLpnByType",
    GENERICBASICDATA: "/generic/basic/data", // created
    GENERICBASICCONFIGDATA: "/generic/basic/config/data",
    GENERICBASICCONFIGSUBMODULEDATA: "/generic/basic/config/subModuleData",
    GENERICBASICCONFIGCLOUMN: "/generic/basic/config/cloumn",
    GENERICAPPENDDATA: "/generic/append/basic/data", // created
    GENERICDELETIONDATA: "/generic/deletion/basic/data", // created
    GENERICMODULESQLTML: "/generic/module/sql",
    GENERIXMODULEALLSQLTML: "/generic/module/allSql",
    MODULEDELETIONSQL: "/generic/module/deletion/sql",
    USEdDEFGENERICPROJECTLIST: "/generic/project/list",
    USEdDEFGENERICUDRPROJRCT: "/generic/udr/project",
    USEdDEFUDRPRODELETION: "/generic/udr/project/deletion",
    USEdDEFUDRPRORJCTFETCH: "/generic/udr/project/fetch",
    GENERICUDRCOPYUSERDEF: "/generic/udr/copy",
    GENERICUGCUSERLIST: "/generic/ugc/user/list",
    GENERICYDRTMLDEFAULT: "/generic/udr/template/default",
    GENERICUDRTEMPLATELIST: "/generic/udr/template/list",
    GENERICUDRTEMPLATE: "/generic/udr/template",
    GENERICUDRTEMPLATEDELETION: "/generic/udr/template/deletion",
    GENERICUDRTEMPLATEREAL: "/generic/udr/template/real",
    GENERICUDRDROPDOWNFIELNAME:"/generic/udr/dropdown/fieldName",
    GENERICDETAILSEQ: "/generic/detail/seq",
    TEMPORTSUBMODULECODE: "/generic/template/subModuleCode",
    GENERICGEMAPMASTER: "/generic/geMapMaster",
    GENERICIMPORTEXCELCOLUMN: "/generic/import/excel/column",
    GENERICDELETEGEMAPMASTER: "/generic/delete/geMapMaster",
    GENERICGEMAPDETAIL: "/generic/geMapDetail",
    GENERICGEMAPMASTERPROJECTCODE: "/generic/geMapMaster/projectCode",
    GENERICGEMAPMASTERTEMPLATE:"/generic/geMapMaster/template",
    GENERICCLONEGEMAPMASTER:"/generic/clone/geMapMaster",
    GENERICIMPORTEXCELTEMPLATE: "/generic/import/excel/template",
    GENERICEXCELCOLUMN: "/generic/excel/column",
    GENERICEXPORTEXCELTEMPLATE:"/generic/export/excel/template",
    GENERICDELETEGEMAPDETAIL: "/generic/delete/geMapDetail",
    GENERICGEMAPMASTERTABLEMANE: '/generic/geMapMaster/tableName',
    GENERICGEMAPMASTERFIELDNAME: '/generic/geMapMaster/fieldName',
    GENERICSUBMODULECODE: "/generic/subModuleCode",
    GENERICCURRENTSUBMODULECODE: "/generic/current/subModuleCode",
    GENERICIMPORTMODULEDATA: "/backend/import/module/data",
    GENERICGEMAPMASTERCOMBINEFIELDNAME:"/generic/geMapMaster/combine/fieldName",
    GENERICEXPORTWXCELDATATEMPLATE: "/generic/export/excel/data/template",
    GENERICEXTGENERICSTMGENERIC: "/generic/extGeneric/stmGeneric",
    GENERICEXPORTEXCELERROR: "/generic/export/excel/error",
    GENERICEXTGENERICCREATION: "/generic/extGeneric/creation",
    GENERICEXTGENERICCREATIONORCLONE: "/generic/extGeneric/AddOrClone",
    GENERICEXTGENERICGEEXTHEADER: "/generic/extGeneric/geExtHeader",
    GENERICEXTGENERICPAGEPROPERTY: "/generic/extGeneric/pageProperty",
    GENERICEXTGENERICGEEXTDETAIL: "/generic/extGeneric/geExtDetail",
    GENERICEXTGENERICCOLUMN: "/generic/extGeneric/column",
    GENERICGEMAPMASTEROPERATIONRULE: "/generic/geMapMaster/operationRule",
    GENERICEXTGENERICGEEXTML: "/generic/extGeneric/geExtMl",
    GENERICEXTGENERICDELGEEXTML: "/generic/extGeneric/del/geExtMl",
    GNERICEXTGENERICCANCEL: "/generic/extGeneric/cancel",
    GENERICNOEDITABLESTATUS: "/generic/nonEditableStatus",
    GENERICNONEDITABLE: "/generic/nonEditable",
    GENERICEXTGENERICGEEXTBEHR: "/generic/extGeneric/geExtBehr",

    CFSADDORDERSHIPMENT: "/cfs/add/order/shipment",
    CFSADDORDERHEADERSHIPMENT: "/cfs/add/orderHeader/shipment",
    CFSADDPALLET: "/cfs/add/pallet",
    CESADDPALLETSHIPMENT: "/cfs/add/pallet/shipment",
    CFSADDPALLETDETAIL: "/cfs/add/palletDetail",
    CFSUPDATEORDERDETAIL: "/cfs/update/orderDetail",
    CFSBATCHUPDATESHIPMENTMAWB: "/cfs/batchUpdate/shipmentMAWB",
    CFSBATCHUPDATE: "/cfs/batchUpdate",
    CFSGETCANCELREASONCODE: "/cfs/cancelReasonCodeList",
    CFSCANCELWITHREASON: "/cfs/cancelWithReason",
    CFSCHECKORDERSTATUS: "/cfs/checkOrderStatus",


  GENERICBEHAVIORCONDITION:"/generic/behavior/condition",
    GENERICDRPDOWNREPORTMASTER: "/generic/dropdown/reportMaster",
    GENERICNAMEBEHAVIORCOLUMN: "/generic/behavior/columnName",
    GENERICBEHAVIORDATASOURCE: "/generic/behavior/dataSource",
    GENERICBEHAVIORVALUE:"/generic/behavior/value",
    GENERICDELBEHAVIORCONDITION: "/generic/del/behavior/condition",
    GENERICEXTGENERICGEEXTSUBPAGE: "/generic/extGeneric/geExtSubPage",
    SCANINWAY: "/scanIn/way",
    SCANSHOW: "/scan/show",
    GENERICFUNC: "/generic/func",
    GETATTACHMENTINFO:"/generic/getAttachment",
    UPDATEATTACHMENT:"/generic/updateAttachment",
    UPLOADATTACHMENT:"/generic/uploadAttachment",
    CHECKUPLOADFILEPATH:"/generic/checkUploadFilePath",
    DOWNLOADATTACHMENT:"/generic/downloadAttachment",

    GETWAVEHEADERBATCHUPDATEINFO:'/generic/getWaveHeaderBatchUpdateInfo',
    WAVEHEADERBATCHUPDATEREF:'/wave/batchUpdateRef',
    WAVEHEADERBATCHUPDATEREFCHECKDUEDATE:"/wave/batchUpdateRefCheckDueDate",

  SUPPORTGETORGS:"/generic/support/getOrgs",
  SUPPORTGETPROJECTS:"/generic/support/getProjects",
  SUPPORTGETPROJECTSALL:"/generic/support/getProjectsAll",
  SUPPORTGETPROJECTUrl:"/generic/support/getProjectUrl",
  SUPPORTSAVELOG:"/generic/support/saveLog",
  SENDSUPPORT:"/generic/support/sendSupport",
  SENDSUPPORTA01REOPENASN:"/generic/support/sendSupportA01ReopenASN",
  SENDSUPPORTC01MOVEPOTOWAREHOUSE:"/generic/support/sendSupportC01MovePOToWarehouse",
  GETSUPPORTHEADERLIST:"/generic/support/getSupportHeaderList",
  GETSUPPORTDETAILLIST:"/generic/support/getSupportDetailList",

	GETMULTILANGUAGEBYSCHEAMA: "/generic/getMultiLanguageByScheama",
    SAVEMULTILANGUAGEBYSCHEAMA: "/generic/saveMultiLanguageByScheama",
    GETMULTILANGUAGEBYBEHRUID: "/generic/getMultiLanguageByBeHrUid",
    SAVEMULTILANGUAGEBYBEHRUID: "/generic/saveMultiLanguageByBeHrUid",
    CONVERTCOUNTRESULTUPLOAD: "/report/generic/convertCountResult/upload",
    CONVERTCOUNTRESULTDOWNLOAD: "/report/generic/convertCountResult/download",
};
